// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  url: 'https://conectio.es/backend',
  linkedinUrl: 'https://linkedin.com/oauth/v2/authorization?response_type=code&client_id=77gkfsqxegbvmk&redirect_uri=https%3A%2F%2Fconectio.es%2Fsession%2Flinkedin-callback&scope=profile%20r_basicprofile%20email%20openid',
  linkedinUrlManual: 'https://linkedin.com/oauth/v2/authorization?response_type=code&client_id=77gkfsqxegbvmk&redirect_uri=https%3A%2F%2Fconectio.es%2Fsession%2Flinkedin-callback-manual&scope=profile%20r_basicprofile%20email%20openid'
};
